const grommetConfig = {
    layer: {
        overlay: {
            background: 'rgba(0,0,0,.9)',
        },
    },
};

export default grommetConfig;
